import './index.scss'

const InputWithIcon = ({type, placeholder, value, onChange, className, icon}) => {
    return (
        <>
            <input type={type} placeholder={placeholder} onChange={onChange} value={value}
                className={`input-icon ${className}`}/>
            <button className="icon">{icon}</button>
        </>
    )
}

export default InputWithIcon
